module.exports = __webpack_public_path__ + "img/td.5921e14e.svg";